export default __webpack_public_path__ + "static/media/key.3b228689.svg";